import React from 'react'
import  axios from 'axios'

const Home = () => {

  const baseUrl='http://crm.miniso.com.mx:8080/api';
  
   const myId = () => {
    let id = [];
    let base = "0123456789ABCDEF";
  
    for (let i = 0; i < 8; i++) {
      let numero = (Math.random() * 15).toFixed(0);
      id.push(base[numero]);
    }
    return id.join("");
  };

  const createNewUser = async(dataUser)=>{
    const endpoint= '/newFlowCreateUserByForm/';
    const options = {
      mode: 'no-cors',
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(dataUser)
    }
    try {
      const response = await axios.post(`${endpoint}`,dataUser);
      //const result = await response.json();
      console.log(response);
      return response.data
    } catch (error) {
      console.log(error);
      return error
    }
  }


  const handleCreateClients = async()=>{
    for (let i = 0; i < 20; i++) {
      const dataUser = {
        cityUser: "CDMX",
        cuponType: "store",
        email: `ppruebasClientesEstress${String(myId())}@testing.com`,
        gender: "male",
        maritalStatus: "single",
        materno: "Hernandez",
        nameUser: "Juan",
        newsLetter: false,
        paterno: "Perez",
        privacy: true,
        tyc: true,
        zipCode: "11111",
        dataID: {},
      };
      const result = await createNewUser(dataUser);
      
      console.log(`ronda:${i}...${result.idAptos},:..${result.idCL},:..${result.idMF}`);
    }
    
  }
  return (
    <div className='bg-secondary p-5'>
      <h1 className='text-primary text-center m-3 bg-light p-3 rounded w-50 ms-auto me-auto'>Cliente pruebas de Estress:...</h1>
      <button onClick={handleCreateClients} className='btn btn-danger fs-3 d-block ms-auto me-auto m-3 p-3 '>Crear clientes:..</button>
    </div>
  )
}

export default Home